import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { Button } from '../Button/index.js';
import { ModalHeader } from '../ModalHeader.js';
import { i18n } from '../../i18n/translate.js';
import { FAIcon } from '../fa-icon/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
var ConfirmationModal = /*#__PURE__*/function (_React$Component) {
  function ConfirmationModal(props) {
    var _this;
    _classCallCheck(this, ConfirmationModal);
    _this = _callSuper(this, ConfirmationModal, [props]);
    _defineProperty(_this, "getModalClasses", function () {
      var _this$props = _this.props,
        modalClass = _this$props.modalClass,
        modalSize = _this$props.modalSize;
      return _formatClassName(['confirm-modal', "modal-size-".concat(modalSize), "".concat(modalClass)]);
    });
    _this.closeWithConfirm = _this.closeWithConfirm.bind(_this);
    return _this;
  }
  _inherits(ConfirmationModal, _React$Component);
  return _createClass(ConfirmationModal, [{
    key: "closeWithConfirm",
    value: function closeWithConfirm(e) {
      this.props.onConfirm(this.props.data, e);
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var _this$props2 = this.props,
        _this$props2$branded = _this$props2.branded,
        branded = _this$props2$branded === void 0 ? false : _this$props2$branded,
        cancelButtonClass = _this$props2.cancelButtonClass,
        _this$props2$cancelBu = _this$props2.cancelButtonText,
        cancelButtonText = _this$props2$cancelBu === void 0 ? i18n.t('Cancel') : _this$props2$cancelBu,
        confirmButtonClass = _this$props2.confirmButtonClass,
        confirmButtonDisabled = _this$props2.confirmButtonDisabled,
        confirmButtonLoading = _this$props2.confirmButtonLoading,
        _this$props2$confirmB = _this$props2.confirmButtonText,
        confirmButtonText = _this$props2$confirmB === void 0 ? i18n.t('OK') : _this$props2$confirmB,
        confirmOnly = _this$props2.confirmOnly,
        id = _this$props2.id,
        onCancel = _this$props2.onCancel,
        chakra = _this$props2.chakra;
      var renderAsLegacy = chakra === 'off';
      return /*#__PURE__*/React.createElement(Modal.Footer, null, !confirmOnly && /*#__PURE__*/React.createElement(Button, {
        autoFocus: true,
        branded: branded,
        className: cancelButtonClass,
        data: {
          action: 'cancel'
        },
        id: "".concat(id, "-cancel-button"),
        label: cancelButtonText,
        onClick: onCancel,
        style: "secondary",
        renderAsLegacy: renderAsLegacy
      }), /*#__PURE__*/React.createElement(Button, {
        autoFocus: confirmOnly,
        branded: branded,
        className: confirmButtonClass,
        data: {
          action: 'confirm'
        },
        disabled: confirmButtonDisabled,
        id: "".concat(id, "-confirm-button"),
        onClick: this.closeWithConfirm,
        style: "primary",
        renderAsLegacy: renderAsLegacy
      }, confirmButtonLoading && /*#__PURE__*/React.createElement(FAIcon, {
        spin: true,
        icon: "spinner"
      }), confirmButtonText));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        canClickOff = _this$props3.canClickOff,
        children = _this$props3.children,
        container = _this$props3.container,
        data = _this$props3.data,
        dialogClass = _this$props3.dialogClass,
        id = _this$props3.id,
        onCancel = _this$props3.onCancel,
        show = _this$props3.show,
        title = _this$props3.title;
      var modalClassName = this.getModalClasses();
      return /*#__PURE__*/React.createElement(Modal, {
        animation: false,
        "aria-labelledby": "".concat(id, "-title"),
        backdrop: canClickOff ? true : 'static',
        backdropClassName: "confirm-modal-backdrop",
        className: modalClassName,
        container: container,
        dialogClassName: "confirm-dialog ".concat(dialogClass),
        id: id,
        keyboard: canClickOff,
        onEntered: this.onEntered,
        onHide: onCancel,
        show: show === undefined || show === null ? !!data : show
      }, /*#__PURE__*/React.createElement(ModalHeader, {
        onCancel: onCancel,
        canClickOff: canClickOff,
        title: title,
        titleId: "".concat(id, "-title")
      }), /*#__PURE__*/React.createElement(Modal.Body, null, children), this.renderFooter());
    }
  }]);
}(React.Component);
_defineProperty(ConfirmationModal, "propTypes", {
  branded: PropTypes.bool,
  confirmButtonClass: PropTypes.string,
  confirmButtonText: PropTypes.string,
  cancelButtonClass: PropTypes.string,
  cancelButtonText: PropTypes.string,
  canClickOff: PropTypes.bool,
  confirmOnly: PropTypes.bool,
  confirmButtonDisabled: PropTypes.bool,
  confirmButtonLoading: PropTypes.bool,
  container: PropTypes.node,
  children: PropTypes.node,
  data: PropTypes.object,
  dialogClass: PropTypes.string,
  modalClass: PropTypes.string,
  modalSize: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  id: PropTypes.string,
  show: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  chakra: PropTypes.oneOf(['off'])
});
_defineProperty(ConfirmationModal, "defaultProps", {
  id: 'confirmation-modal',
  modalClass: '',
  modalSize: 'small',
  dialogClass: '',
  confirmButtonDisabled: false,
  confirmButtonLoading: false
});
ConfirmationModal.displayName = "ConfirmationModal";
export { ConfirmationModal };